import { colors, spacing } from "app/utils/theme";
import { isFrontlyAdmin, parseBoolean } from "app/utils/utils";

import Checkbox from "@mui/material/Checkbox";
import { Text } from ".";
import { get } from "lodash";

const CheckboxComponent = ({ data }) => {
  const value = get(data, "value", false);

  const isActive = parseBoolean(value);

  const primaryColor = "var(--primary)";

  let label = data.checkboxDescription;
  if (isFrontlyAdmin) {
    label = data.checkboxDescription || data.label;
  }

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        gap: spacing.s1,
        marginTop: spacing.s1,
      }}
    >
      <Checkbox
        color="primary"
        checked={isActive}
        disabled={data.disabled}
        onChange={() => data?.onChange(!isActive)}
        value={isActive}
        style={{ padding: "0px" }}
        sx={{
          color: data.darkMode && colors.darkModeLightGrey,
          "&.Mui-checked": {
            color: primaryColor,
          },
        }}
      />
      <Text
        data={{
          text: label,
          margin: "0 0 4px 0",
          fontStyle: "bodySm",
        }}
      />
    </div>
  );
};

export default CheckboxComponent;
